if (typeof window.Slider === 'undefined') {
    window.Slider = class {
        constructor(slider) {

            if(slider == null)
              return;
          
            this.slider = slider;

            // Initial values
          
            this.shouldFocusSlidesOnCampaign = slider.getAttribute('nw-carousel-focus-on-campaign') === 'true' ? true : false;
            this.isCarousel = slider.getAttribute('nw-carousel') === 'true' ? true : false;
            this.isSingleSlide = slider.getAttribute('nw-is-single-slide') === 'true' ? true : false;
            this.forwardRestarts = slider.getAttribute('nw-forward-restarts') === 'true' ? true : false;
            this.slideDelay = slider.getAttribute('nw-carousel-slide-delay');
            this.mobileDynamicWidthSizing = slider.getAttribute('nw-slider-mobile-dynamic-width-sizing') || null;
            this.dynamicHeightSizing = slider.hasAttribute('nw-slider-dynamic-height-sizing') ? true : false;

            this.preventSlide = false;
            this.swipeThreshold = 20;
            this.currentSlidePosition = 0;
            this.currentFramePosition = 0;

            this.isCarouselScrolling = null;
            this.touchX_PositionStart = 0;
            this.touchY_PositionStart = 0;
            this.currentX = 0;
            this.changeX = 0;
            this.touchX_PositionPrevious = 0;
            this.touchX_PositionCurrent = 0;
            this.touchY_PositionPrevious = 0;
            this.touchY_PositionCurrent = 0;

            this.carouselInterval;

            // Elements
            this.slideList = slider.getElementsByClassName("nw-slide");
            this.sliderWrapper = slider.getElementsByClassName('nw-slider-wrapper')[0];
            this.sliderRow = slider.getElementsByClassName('nw-slider-row')[0];
            this.sampleSlide = this.slideList[0];
            this.backButton = slider.querySelector("[slider-button='back']");
            this.forwardButton = slider.querySelector("[slider-button='forward']");
            this.navDotContainer = slider.querySelector('.nw-navigation-dots');
            this.carouselActionButton = slider.querySelector('.nw-carousel-action-btn');

            this.navDots = [];

            this.isInitialized = false;
            this.numberOfFrames = 0;
            this.numberOfSlides = 0;
            this.maxSlidePosition = 0;
            this.slideWidth = 0;
            this.slideHeight = 0;
            this.slidesShownHorizontal = 0;
            this.slidesShownVertical = 0;
        }

        addKeyPressListenerToDot(dot){
            dot.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault()
                    this.slideToPosition(event);
                }
                // remove focus
                dot.blur();
            })
        }
        initialize() {
            if (!this.sliderRow) {
                return;
            }

            // Reset sizes & created elements (ie. for reinitialization)
            this.sliderRow.removeAttribute('style');
            this.sliderWrapper.removeAttribute('style');
            for (let slide of this.slideList) {
                slide.removeAttribute('style');

                if (slide.classList.contains('clone')) {
                    slide.remove();
                }
            }
            this.slideList = this.slider.getElementsByClassName("nw-slide");

            clearInterval(this.carouselInterval);
            this.resetPreventSlideSet();

            // Skip the initialization if there are no slides rendered. This can happend for example for the
            // PDP page where the slides are loaded async, with XHR.
            if (this.slideList.legnth === 0) {
                return;
            }

            if (this.slideList[0].offsetParent === null) {
                return;
            }

            var wasInitialized = this.isInitialized;
            this.isInitialized = true;

            // Dynamic height based on largest slide if set
            if (this.dynamicHeightSizing) {
                const biggestSlideHeight = this.getBiggestSlideHeight();
                this.sliderWrapper.style.height = `${biggestSlideHeight}px`;
            }

            if (this.shouldFocusSlidesOnCampaign) {
                this.reorderSlidesForCampaign();
            }

            // Calculations
            if (this.sampleSlide) {
                if (this.slideList.length == 1) {
                    this.preventSlideSet();
                }

                let pageWidth = document.querySelector('body').offsetWidth;
                let slideStyle = getComputedStyle(this.sampleSlide);

                this.slideWidth = this.sampleSlide.offsetWidth + parseInt(slideStyle.marginLeft) + parseInt(slideStyle.marginRight);
                this.slideHeight = this.sampleSlide.offsetHeight + parseInt(slideStyle.marginTop) + parseInt(slideStyle.marginBottom);

                let wrapperWidth = this.sliderWrapper.offsetWidth;
                let wrapperHeight = this.sliderWrapper.offsetHeight;

                this.slidesShownHorizontal = Math.max(1, Math.floor(wrapperWidth / this.slideWidth));
                this.slidesShownVertical = Math.max(1, Math.floor(wrapperHeight / this.slideHeight));

                this.numberOfSlides = this.slideList.length;
                this.numberOfFrames = Math.ceil(this.numberOfSlides / (this.slidesShownVertical * this.slidesShownHorizontal));

                let sliderRowWidth = this.isCarousel ? (wrapperWidth * (this.numberOfFrames + 1)) : (wrapperWidth * this.numberOfFrames);
                this.sliderRow.style.width = `${sliderRowWidth}px`;
                this.maxSlidePosition = this.calculateMaxSlidePosition();

                if (this.numberOfSlides <= this.slidesShownHorizontal) {
                    this.preventSlideSet();
                }

                if (this.isSingleSlide) {
                    for (let slide of this.slideList) {
                        slide.style.width = `${this.slideWidth}px`;
                    }
                }

                // Conditional Settings
                if (this.isCarousel) {
                    var cloneSlide = this.slideList[0].cloneNode(true);
                    cloneSlide.classList.add('clone');
                    // avoid duplcating ID of parent
                    cloneSlide.id = this.slideList[0].id + "-clone";
                    this.sliderRow.appendChild(cloneSlide);
                }

                if (this.navDotContainer) {
                    this.navDotContainer.querySelectorAll('li').forEach(dot => dot.remove());
                    this.navDots = [];
                }
                if (this.navDotContainer && this.numberOfFrames > 1) {
                    if (!this.preventSlide) {
                        for (var i = 0; i < this.numberOfFrames; i++) {
                            const button = document.createElement("button");
                            button.setAttribute('tabindex', '0')
                            button.classList.add('dot');
                            button.setAttribute('dot-number', i);
                            button.setAttribute('aria-label', 'Go to slide ' + (i + 1));

                            if (i == 0) {
                                button.classList.add('active');
                                button.setAttribute('aria-current', 'true');
                            }

                            button.addEventListener("click", this.slideToPosition.bind(this));
                            this.addKeyPressListenerToDot(button)

                            const dotty = document.createElement("li");
                            dotty.appendChild(button)
                            this.navDotContainer.appendChild(dotty);
                            this.navDots.push(button);
                        }
                    }
                }

                if (this.mobileDynamicWidthSizing != null) {
                    let toggle = false;
                    if (this.mobileDynamicWidthSizing.includes('<')) {
                        let val = this.mobileDynamicWidthSizing.split('<')[1];
                        if (pageWidth < val) {
                            toggle = true;
                        }
                    } else if (this.mobileDynamicWidthSizing.includes('>')) {
                        let val = this.mobileDynamicWidthSizing.split('>')[1];
                        if (pageWidth > val) {
                            toggle = true;
                        }
                    } else if (this.mobileDynamicWidthSizing.includes('=')) {
                        let val = this.mobileDynamicWidthSizing.split('=')[1];
                        if (pageWidth == val) {
                            toggle = true;
                        }
                    }

                    if (toggle) {
                        let rowWidth = this.numberOfSlides * 100;
                        let width = 100 / this.numberOfSlides;

                        this.sliderWrapper.style.width = `100%`;
                        this.sliderRow.style.width = `${rowWidth}%`;
                        for (let slide of this.slideList) {
                            slide.style.width = `${width}%`;
                        }

                        slideStyle = getComputedStyle(this.sampleSlide);
                        this.slideWidth = this.sampleSlide.offsetWidth + parseInt(slideStyle.marginLeft) + parseInt(slideStyle.marginRight);

                        // Get real pixel width of wrapper
                        wrapperWidth = this.sliderWrapper.offsetWidth;
                    }
                }

                if (this.currentSlidePosition < -this.maxSlidePosition) {
                    this.currentSlidePosition = -this.maxSlidePosition;
                    this.currentFramePosition = this.maxSlidePosition;

                    this.slide();
                }

                this.setPartialVisibleClass();

                // Listeners
                if (this.backButton && !wasInitialized) {
                    this.backButton.addEventListener("click", this.slideBack.bind(this));
                }
                if (this.forwardButton && !wasInitialized) {
                    this.forwardButton.addEventListener("click", this.slideForward.bind(this));
                }
                this.checkButtons();

                this.emitSlideEvent();

                if (!wasInitialized) {
                    this.sliderRow.addEventListener('touchstart', this.touchStart.bind(this), false);
                    this.sliderRow.addEventListener('touchmove', this.touchMove.bind(this), false);
                    this.sliderRow.addEventListener('touchend', this.touchEnd.bind(this), false);

                    document.addEventListener('touchmove', function(ev) {
                        if (this.isCarouselScrolling) {
                            ev.preventDefault();
                        }
                    }.bind(this), { passive:false });
                }

                // Start Carousel
                if (this.isCarousel) {
                    if (!this.preventSlide) {
                        this.carouselInterval = setInterval(this.slideForward.bind(this), this.slideDelay);
                    }
                }

                if (this.carouselActionButton && this.isCarousel) {
                    this.carouselActionButton.classList.remove('play');
                    this.carouselActionButton.classList.add('pause');

                    if (!wasInitialized) {
                        this.carouselActionButton.addEventListener('click', () => {
                            if (!this.carouselInterval) {
                                this.carouselInterval = setInterval(this.slideForward.bind(this), this.slideDelay);

                                this.carouselActionButton.classList.add('pause');
                                this.carouselActionButton.classList.remove('play');
                                this.carouselActionButton.ariaLabel = 'Pause';
                            } else {
                                clearInterval(this.carouselInterval);
                                this.carouselInterval = null;

                                this.carouselActionButton.classList.add('play');
                                this.carouselActionButton.classList.remove('pause');
                                this.carouselActionButton.ariaLabel = 'Play';
                            }
                        });
                    }
                }

                if (!wasInitialized) {
                    const debouncedInitialize = debounce(() => {
                        this.initialize();
                    }, 300);

                    // reinitialize on windoww resizes
                    window.addEventListener('resize', debouncedInitialize);

                    // Re-initialize on debounced slider images load
                    const images = this.slider.querySelectorAll('img');
                    images.forEach(image => {
                        if (image.complete) {
                            debouncedInitialize();
                        } else {
                            image.addEventListener('load', debouncedInitialize);
                        }
                    });

                    /*
                    // here we handle random font size increases for example, directly applied to the HTML by the client (screen reader etc)
                    if (this.dynamicHeightSizing) {
                        setInterval(() => {
                            if (this.slideList.length === 0) {
                                return;
                            }

                            // If the slides are invisible
                            if (this.slideList[0].offsetParent === null) {
                                return;
                            }

                            const biggestSlideHeight = this.getBiggestSlideHeightWithAuto();
                            const wrapperStyleHeight = parseInt(this.sliderWrapper.style.height, 10);

                            // 10% different triggers the reinitialization
                            const triggerMinGap = wrapperStyleHeight * 0.1;
                            if (Math.abs(biggestSlideHeight - wrapperStyleHeight) >= triggerMinGap) {
                                this.initialize();
                            }
                        }, 2000);
                    }
                    */

                }

                this.slider.classList.add("slider-initialized");
            }
        }

        getBiggestSlideHeight() {
            let biggestSlideHeight = 0;
            for (let slide of this.slideList) {
                let _slideStyle = getComputedStyle(slide);
                let _slideHeight = slide.offsetHeight + parseInt(_slideStyle.marginTop) + parseInt(_slideStyle.marginBottom);
                biggestSlideHeight = biggestSlideHeight >= _slideHeight ? biggestSlideHeight : _slideHeight;
            }

            return biggestSlideHeight;
        }

        getBiggestSlideHeightWithAuto() {
            let biggestSlideHeight = 0;
            for (let slide of this.slideList) {
                const clone = slide.cloneNode(true);
                clone.style.position = "absolute";
                clone.style.left = '-30000px';
                clone.style.height = "auto";
                this.slider.appendChild(clone);

                let _slideStyle = getComputedStyle(slide);
                let _slideHeight = clone.offsetHeight + parseInt(_slideStyle.marginTop) + parseInt(_slideStyle.marginBottom);

                clone.remove();

                biggestSlideHeight = biggestSlideHeight >= _slideHeight ? biggestSlideHeight : _slideHeight;
            }

            return biggestSlideHeight;
        }

        // Touch Functionality
        touchStart(event) {
            if (!this.preventSlide) {
                this.noAnimateSet();
                this.touchX_PositionPrevious = event.touches[0].clientX;
                this.touchY_PositionPrevious = event.touches[0].clientY;

                this.touchX_PositionStart = event.touches[0].clientX;
                this.touchY_PositionStart = event.touches[0].clientY;
            }
        }

        touchMove(event) {
            if (!this.preventSlide) {
                this.touchX_PositionCurrent = event.touches[0].clientX;
                this.touchY_PositionCurrent = event.touches[0].clientY;

                if (this.isCarouselScrolling === null) {
                    if (Math.abs(this.touchX_PositionStart - this.touchX_PositionCurrent) > 20) {
                      this.isCarouselScrolling = true;
                    }
                    if (Math.abs(this.touchY_PositionStart - this.touchY_PositionCurrent) > 20) {
                      this.isCarouselScrolling = false;
                    }
                }
                if (!this.isCarouselScrolling) {
                    return;
                }

                this.changeX = this.touchX_PositionPrevious - this.touchX_PositionCurrent;
                if (this.changeX > this.swipeThreshold) {
                    this.changeX = this.changeX * 3;
                }

                // This is how much we can scroll - we substract one, because we don't count the last slide, we cannot scroll past it.
                // slideWidth * slidesShownHorizontal is basically frame width.
                // Also we cannot scroll backwards.
                const minX = -(this.numberOfFrames - 1) * this.slideWidth * this.slidesShownHorizontal;
                const changedCurrentX = this.currentX - this.changeX;
                // Let's try some min / max bounds for the scroll.
                if (changedCurrentX > 0 || changedCurrentX < minX) {
                    return;
                }

                this.currentX = changedCurrentX;
                this.sliderRow.style.transform = `translateX(${this.currentX}px)`;
                this.touchX_PositionPrevious = this.touchX_PositionCurrent;
                if (Math.sign(this.changeX) < 0) {
                    this.currentSlidePosition = Math.ceil(this.currentX / this.slideWidth);
                } else if (Math.sign(this.changeX) > 0) {
                    this.currentSlidePosition = Math.floor(this.currentX / this.slideWidth);
                } else {
                    this.currentSlidePosition = this.currentSlidePosition;
                }

                this.changeX = (this.changeX / 2);
                if (this.changeX < 1 || this.changeX > -1) {
                    this.changeX = 0;
                }
            }
        }

        touchEnd() {
            this.isCarouselScrolling = null;

            if (!this.preventSlide) {
                let touch = true;
                this.animateSet();
                this.slide(touch);
            }
        }

        // Slide Functionality
        slideForward() {
            if (this.preventSlide) {
                return;
            }

            this.currentFramePosition += this.slidesShownHorizontal;
            this.currentSlidePosition = this.currentSlidePosition - this.slidesShownHorizontal;

            if (this.currentSlidePosition < -this.maxSlidePosition) {
                this.currentSlidePosition = 0;
                this.currentFramePosition = 0;
            }

            this.slide();
        }

        slideBack() {
            if (this.preventSlide) {
                return;
            }

            this.currentFramePosition -= this.slidesShownHorizontal;
            this.currentSlidePosition = this.currentSlidePosition < 0 ? this.currentSlidePosition + this.slidesShownHorizontal : 0;
            this.slide();
        }

        slideToPosition(e) {
            if (this.preventSlide) {
                return;
            }

            let target = e.target;
            // BUG: waas concating a string, now is doing math
            let number = parseInt(target.getAttribute('dot-number'));
            this.currentFramePosition = number;
            this.currentSlidePosition = -(number * this.slidesShownHorizontal);
            target.blur();
            this.slide();
        }

        slide(touch) {
            if (!this.preventSlide) {
                if (this.isCarousel && !touch) {
                    if (this.checkMaxPlusOnePosition()) {
                        this.noAnimateSet();
                        this.currentSlidePosition = 0;
                        this.currentFramePosition = 0;
                        this.resetInterval(0);
                        this.moveSlider();
                    } else {
                        this.animateSet();
                        this.resetInterval(this.slideDelay);
                        this.moveSlider();
                    }
                } else if (touch) {
                    this.touchMoveSlider();
                } else {
                    this.moveSlider();
                }

                this.setPartialVisibleClass();

                this.checkDots();

                this.checkButtons();

                this.emitSlideEvent();
            }
        }

        checkDots() {
            if (this.navDots.length > 0) {
                for (let i = 0; i < this.navDots.length; i++) {
                    const button = this.navDots[i]      
                    button.classList.remove('active');
                    button.removeAttribute('aria-current');
                }
                this.currentFramePosition = this.currentFramePosition > this.maxSlidePosition ? 0 : this.currentFramePosition;

                const dotIndex = Math.ceil(this.currentFramePosition / this.slidesShownHorizontal);

                if (this.navDots[dotIndex]) {
                    const button = this.navDots[dotIndex]
                    button.classList.add('active');
                    button.setAttribute('aria-current', 'true');
                }
            }
        }

        emitSlideEvent() {
            this.currentFramePosition = this.currentFramePosition > this.maxSlidePosition ? 0 : this.currentFramePosition;

            const event = new CustomEvent("slide", { detail: this.slideList[this.currentFramePosition] });
            this.slider.dispatchEvent(event);
        }

        moveSlider() {
            /**
             * If the last slide is partially displayed, make sure we start the new "page" with it.
             * This is taken care of also when calculating the number of dots to be displayed.
             */
            this.currentX = -this.currentFramePosition * this.slideWidth;
            this.sliderRow.style.transform = `translateX(${this.currentX}px)`;
        }

        touchMoveSlider() {
            // Compute the frame number, using the obtained currentSlidePosition and the number of horizontal slides per frame
            this.currentFramePosition = -this.currentSlidePosition;

            this.moveSlider();
        }

        calculateMaxSlidePosition() {
            const slidesPerRow = Math.ceil(this.numberOfSlides / this.slidesShownVertical);
            let pages = Math.floor(slidesPerRow / this.slidesShownHorizontal);
            const rest = slidesPerRow % this.slidesShownHorizontal;

            // If we the last page is full, substract one from the divison result
            if (rest === 0) {
                pages--;
            }

            return pages * this.slidesShownHorizontal;
        }

        animateSet() {
            this.sliderRow.classList.remove('no-animate');
        }

        noAnimateSet() {
            this.sliderRow.classList.add('no-animate');
        }

        setPartialVisibleClass() {
            for (let slide of this.slideList) {
                slide.classList.remove('partial-visible');
                slide.setAttribute('aria-hidden', 'true');
                // Focasable Elemnts
                slide.setAttribute('tabindex', '-1');

                // Find all <a> elements inside the slide and set their tabindex to -1
                const links = slide.querySelectorAll('a');
                links.forEach(link => {
                    link.setAttribute('tabindex', '-1')
                });

                // Find all <button> elements inside the slide and set their tabindex to -1
                const butts = slide.querySelectorAll('button');
                butts.forEach(butt => {
                    butt.setAttribute('tabindex', '-1')
                });
            }

            // Set the partial-visible class
            var lastFullyVisibleSlideIndex = Math.abs(this.currentSlidePosition) + this.slidesShownHorizontal - 1;
            if (lastFullyVisibleSlideIndex < this.numberOfSlides - 1) {
                this.slideList[lastFullyVisibleSlideIndex + 1].classList.add('partial-visible');
            }

            if (lastFullyVisibleSlideIndex >= this.slideList.length) {
                lastFullyVisibleSlideIndex = this.slideList.length - 1;
            }

            for (let i = Math.abs(this.currentSlidePosition); i <= lastFullyVisibleSlideIndex; i++) {
                this.slideList[i].setAttribute('aria-hidden', 'false');

                // Focasable Elemnts
                this.slideList[i].removeAttribute('tabindex');

                // Find all <a> elements that are :not(.card-wrapper-v3-image-primary-inner and inside the slide and remove their tabindex so buttons and titles are still clickable
                const links = this.slideList[i].querySelectorAll(
                    'a:not(.card-wrapper-v3-image-primary-inner)',
                );
                links.forEach((link) => {
                    link.removeAttribute('tabindex');
                });

                // Find all <button> elements inside the slide and set their tabindex to -1
                const butts = this.slideList[i].querySelectorAll('button');
                butts.forEach(butt => {
                    butt.removeAttribute('tabindex');
                });
            }
        }

        checkButtons() {
            if (this.backButton ) {
                this.backButton.classList.remove('no-slides');

                if (this.currentFramePosition > 0) {
                    this.backButton.disabled = false;
                    this.backButton.classList.remove('hide');
                } else {
                    this.backButton.disabled = true;
                    this.backButton.classList.add('hide');
                }
            }

            if (this.forwardButton) {
                this.forwardButton.classList.remove('no-slides');

                if (Math.ceil(this.currentFramePosition / this.slidesShownHorizontal) < this.numberOfFrames - 1) {
                    this.forwardButton.disabled = false;
                    this.forwardButton.classList.remove('hide', 'last-frame');
                } else {
                    if (this.forwardRestarts) {
                        this.forwardButton.classList.add('last-frame');
                    } else {
                        this.forwardButton.disabled = true;
                        this.forwardButton.classList.add('hide');
                    }
                }
            }

            if (this.numberOfFrames === 1) {
                if (this.forwardButton) {
                    this.forwardButton.disabled = true;
                    this.forwardButton.classList.add('no-slides');
                }

                if (this.backButton) {
                    this.backButton.disabled = true;
                    this.backButton.classList.add('no-slides');
                }
            }
        }

        checkMaxPlusOnePosition() {
            if (this.currentSlidePosition <= -(this.maxSlidePosition + 2)) {
                return true;
            } else {
                return false;
            }
        }

        preventSlideSet() {
            this.preventSlide = true;
            this.slider.classList.add('prevent-slide');
        }

        resetPreventSlideSet() {
            this.preventSlide = false;
            this.slider.classList.remove('prevent-slide');
        }

        resetInterval(newDelay) {
            if (!this.preventSlide && this.carouselInterval) {
                clearInterval(this.carouselInterval);
                this.carouselInterval = setInterval(this.slideForward.bind(this), newDelay);
            }
        }

        reorderSlidesForCampaign() {
            const urlQueryParams = new URLSearchParams(window.location.search);
            const queryCampaignName = urlQueryParams.get('_cs');

            if (queryCampaignName) {
                for (const slide of this.slideList) {
                    const slideCampaigns = (slide.getAttribute('data-focus-campaigns') ?? '').split(',').map(item => item.trim());
                    if (slideCampaigns.includes(queryCampaignName)) {
                        this.sliderRow.prepend(slide);

                        // Reset the list on changes
                        this.slideList = this.slider.getElementsByClassName("nw-slide");
                        this.sampleSlide = this.slideList[0];
                    }
                }
            }
        }
    }
}
